<template>
	<section class="header-wrap">
		<div @click="closeAllSubmenuesOnBg" class="header-bg" v-if="isAdaptiveMenuBGShown || isFeaturesShown || areClientsShown || isHelpShown || areResourcesShown"></div>
		<header class="header">
			<AboveHeader />
			<div class="header__inner" v-bind:class="{ 'header__inner--shadow': isHeaderWithShadow }">
				<div class="header__container">
					<div class="header__logo">
						<a href="/">
              <img src="/dist/img/logo-aT.svg" alt="actiTIME logo">
            </a>
          </div>
          <div class="header-menues" v-if="isMenuShown">
            <transition name="slide" mode="out-in">
							<div class="header__menu-wrap" v-bind:class="{ 'header__menu-wrap--visible': isAdaptiveMainMenuShown }">
								<ul class="header__menu">
									<li v-for="menuItem in menuList" class="header__li" v-bind:class="[!menuItem.url ? 'header__li--parent' : '', menuItem.isActive ? 'header__li--active' : '', highlightMenuItem(menuItem.name) ? 'header__li--open' : '']" @click="openSubmenu(menuItem)">
										<a v-if="menuItem.url" v-bind:href="menuItem.url" class="header__link">{{ menuItem.name }}</a>
										<template v-else>
											<span>{{ menuItem.name }}</span>
										</template>
										<transition name="fade" mode="out-in">
											<Features v-if="isMobileMainMenuShown && isAdaptiveMainMenuShown && isFeaturesShown && isMenuShown && menuItem.name === activeItem" @close-menu="closeAllSubmenues"></Features>
											<Clients v-if="isMobileMainMenuShown && isAdaptiveMainMenuShown && areClientsShown && isMenuShown && menuItem.name === activeItem" @close-menu="closeAllSubmenues"></Clients>
											<Help v-if="isMobileMainMenuShown && isAdaptiveMainMenuShown && isHelpShown && isMenuShown && menuItem.name === activeItem" @close-menu="closeAllSubmenues"></Help>
											<Resources v-if="isMobileMainMenuShown && isAdaptiveMainMenuShown && areResourcesShown && isMenuShown && menuItem.name === activeItem" @close-menu="closeAllSubmenues"></Resources>
										</transition>
									</li>
								</ul>
								<div class="header__buttons">
									<a class="button header__login-button" href="/login-to-product">Log in</a>
									<a class="button header__button" href="/free-online-trial">Try Free</a>
								</div>
								<transition name="fade" mode="out-in">
									<Features v-if="!isMobileMainMenuShown && isAdaptiveMainMenuShown && isFeaturesShown && isMenuShown" @close-menu="closeAllSubmenues"></Features>
									<Clients v-if="!isMobileMainMenuShown && isAdaptiveMainMenuShown && areClientsShown && isMenuShown" @close-menu="closeAllSubmenues"></Clients>
									<Help v-if="!isMobileMainMenuShown && isAdaptiveMainMenuShown && isHelpShown && isMenuShown" @close-menu="closeAllSubmenues"></Help>
									<Resources v-if="!isMobileMainMenuShown && isAdaptiveMainMenuShown && areResourcesShown && isMenuShown" @close-menu="closeAllSubmenues"></Resources>
								</transition>
								<ATInAction v-if="isAdaptiveMainMenuShown && isMenuShown && !areResourcesShown" />
								<ATInAction v-if="isAdaptiveMainMenuShown && isMenuShown && areResourcesShown" :customItems="moreItems" />
							</div>
						</transition>
					</div>
					<div class="header__burger" v-bind:class="{ 'header__burger--close': isMenuShown }" @click="openAdaptiveMenu">
						<span></span>
					</div>
				</div>
			</div>
			<transition name="slide" mode="out-in">
				<Features v-if="!isAdaptiveMainMenuShown && isFeaturesShown && isMenuShown" @close-menu="closeAllSubmenues"></Features>
				<Clients v-if="!isAdaptiveMainMenuShown && areClientsShown && isMenuShown" @close-menu="closeAllSubmenues"></Clients>
				<Help v-if="!isAdaptiveMainMenuShown && isHelpShown && isMenuShown" @close-menu="closeAllSubmenues"></Help>
				<Resources v-if="!isAdaptiveMainMenuShown && areResourcesShown && isMenuShown" @close-menu="closeAllSubmenues"></Resources>
			</transition>
		</header>
	</section>
</template>
<script>
import Features from './Features.vue';
import Clients from '../header/Clients.vue';
import Resources from '../header/Resources.vue';
import Help from '../header/Help.vue';
import ClickOutside from 'vue-click-outside';
import ATInAction from './ATInAction.vue';
import AboveHeader from './AboveHeader.vue';

export default {
	data() {
		return {
			isHeaderWithShadow: false,
			isAdaptiveMainMenuShown: false,
			isMobileMainMenuShown: false,
			isMenuShown: true,
			isSubmenuShown: false,
			isFeaturesShown: false,
			isHelpShown: false,
			areClientsShown: false,
			areResourcesShown: false,
			submenuAdaptiveTitle: null,
			activeItem: '',
			isOpenLink: false,
			menuList: [
				{
					name: 'Features',
					classes: ['header__li--parent'],
					isActive: false,
				},
				{
					name: 'Clients',
					classes: ['header__li--parent'],
					isActive: false,
				},
				{
					url: '/pricing',
					name: 'Pricing',
					classes: [],
					isActive: false,
				},
				{
					name: 'Help Center',
					classes: ['header__li--parent'],
					isActive: false,
				},
				{
					name: 'Resources',
					classes: ['header__li--parent'],
					isActive: false,
				},
			],
			moreItems: [
			{
					class: 'header-submenu__item--custom-items',
					name: 'E-Book',
					url: '/ebook/how-to-choose-right-time-tracker',
					icon: '/dist/img/header/business-tools/ebook.svg',
				},
				{
					class: 'header-submenu__item--custom-items',
					name: 'Business Templates',
					url: '/templates',
					icon: '/dist/img/header/business-tools/business.svg',
				},
				{
					class: 'header-submenu__item--custom-items',
					name: 'Overtime Calculator',
					url: '/overtime-calculator',
					icon: '/dist/img/header/business-tools/calculator.svg',
				},
				{
					class: 'header-submenu__item--custom-items',
					name: "Time Trackers' List",
					url: '/timesheet-software-list',
					icon: '/dist/img/header/business-tools/time.svg',
				},
			],
		};
	},

	methods: {
		onScroll(event) {
			if (!this.isAdaptiveMenuBGShown && !this.isFeaturesShown && !this.areClientsShown && !this.isHelpShown && !this.areResourcesShown) {
				window.scrollY > 50 ? (this.isHeaderWithShadow = true) : (this.isHeaderWithShadow = false);
			}
		},

		onResize(event) {
			this.checkIfMenuIsOpen();
			this.checkIfBodyIsScrollable();
		},

		checkIfMenuIsOpen() {
			if (!this.isAdaptiveMenuBGShown) {
				window.innerWidth > 992 ? (this.isMenuShown = true) : (this.isMenuShown = false);
			}
			if (window.innerWidth > 992) {
				this.isAdaptiveMenuBGShown = false;
				this.isAdaptiveMainMenuShown = false;
				this.isMobileMainMenuShown = false;
			}
			if (window.innerWidth <= 992) {
				this.isAdaptiveMainMenuShown = true;

				if (!this.isAdaptiveMenuBGShown) {
					this.isFeaturesShown = false;
					this.areClientsShown = false;
					this.isHelpShown = false;
					this.areResourcesShown = false;
					this.makeAllMenuItemsNotActive();
				}
			}

			if (window.innerWidth <= 768) {
				this.isMobileMainMenuShown = true;

				if (!this.isAdaptiveMenuBGShown) {
					this.isFeaturesShown = false;
					this.areClientsShown = false;
					this.isHelpShown = false;
					this.areResourcesShown = false;
					this.makeAllMenuItemsNotActive();
				}
			}
		},

		openAdaptiveMenu() {
			this.isMenuShown = !this.isMenuShown;
			this.isAdaptiveMenuBGShown = !this.isAdaptiveMenuBGShown;
			if (!this.isMenuShown) {
				this.showAdaptiveMainMenu();
			}
			this.checkIfBodyIsScrollable();
		},

		showAdaptiveMainMenu() {
			this.isAdaptiveMainMenuShown = true;
			this.isFeaturesShown = false;
			this.areClientsShown = false;
			this.isHelpShown = false;
			this.areResourcesShown = false;
			this.makeAllMenuItemsNotActive();
		},

		openSubmenu(menuItem) {
			this.activeItem = menuItem.name;
			this.menuList.forEach((item) => {
				if (item.name !== menuItem.name) {
					item.isActive = false;
				}
			});

			menuItem.isActive = !menuItem.isActive;

			if (menuItem.name === 'Features') {
				this.isFeaturesShown = !this.isFeaturesShown;
				this.areClientsShown = false;
				this.isHelpShown = false;
				this.areResourcesShown = false;
			} else if (menuItem.name === 'Clients') {
				this.areClientsShown = !this.areClientsShown;
				this.isFeaturesShown = false;
				this.isHelpShown = false;
				this.areResourcesShown = false;
			} else if (menuItem.name === 'Help Center') {
				this.isHelpShown = !this.isHelpShown;
				this.isFeaturesShown = false;
				this.areClientsShown = false;
				this.areResourcesShown = false;
			} else if (menuItem.name === 'Resources') {
				this.areResourcesShown = !this.areResourcesShown;
				this.isFeaturesShown = false;
				this.areClientsShown = false;
				this.isHelpShown = false;
			}

			this.submenuAdaptiveTitle = menuItem.name;
			if (!this.isHeaderWithShadow) {
				this.isHeaderWithShadow = true;
			} else if (!this.isAdaptiveMenuBGShown && !this.isFeaturesShown && !this.areClientsShown && !this.isHelpShown && !this.areResourcesShown) {
				window.scrollY > 50 ? (this.isHeaderWithShadow = true) : (this.isHeaderWithShadow = false);
			}

			this.checkIfBodyIsScrollable();
		},

		closeAllSubmenuesOnBg() {
			if (!this.isAdaptiveMenuBGShown && (this.areResourcesShown || this.isFeaturesShown || this.areClientsShown || this.isHelpShown)) {
				this.areResourcesShown = false;
				this.isFeaturesShown = false;
				this.areClientsShown = false;
				this.isHelpShown = false;
				this.makeAllMenuItemsNotActive();
			}
			if (this.isAdaptiveMainMenuShown) {
				this.openAdaptiveMenu();
			}
			this.activeItem = '';
		},

		closeAllSubmenues() {
			this.isOpenLink = true;
			this.closeAllSubmenuesOnBg();
		},

		makeAllMenuItemsNotActive() {
			this.menuList.forEach((item) => {
				item.isActive = false;
			});
		},

		checkIfBodyIsScrollable() {
			if (window.innerWidth <= 992 && this.isAdaptiveMenuBGShown) {
				// document.body.style.cssText = "background-color: rgba(0, 0, 0, 0.3)";
			} else {
				document.body.style.cssText = 'overflow-y: auto';
			}
		},
    highlightMenuItem (menuItem) {
      const path = window.location.pathname.replace('/', '');
      const featuresPaths = ['all-actitime-features', 'simple-time-tracking', 'project-and-task-management', 'efficient-team-management', 'flexible-product-configuration', 'powerful-time-reports', 'project-cost-and-client-billing', 'integrations', 'customer-care'];
      const helpPaths = ['user-guide', 'faq-start', 'api-documentation', 'administration-guide', 'how-to-videos'];
      const resourcesPaths = ['everything-you-need-to-know', 'project-cost-management', 'project-time-estimation', 'overtime-guide', 'getting-more-efficient-with-actitime', 'time-management-guide', 'remote-work-guide'];
      if (featuresPaths.includes(path) && menuItem === 'Features' && !this.areClientsShown && !this.areResourcesShown && !this.isHelpShown && !this.isOpenLink) {
				return true;
			}
			if (path.split('/')[0] === 'testimonials' && menuItem === 'Clients' && !this.isFeaturesShown && !this.areResourcesShown && !this.isHelpShown && !this.isOpenLink) {
				return true;
			}
			if (path === 'pricing' && menuItem === 'Pricing' && !this.isFeaturesShown && !this.areClientsShown && !this.isHelpShown && !this.areResourcesShown && !this.isOpenLink) {
				return true;
			}
			if (helpPaths.includes(path) && menuItem === 'Help Center' && !this.isFeaturesShown && !this.areResourcesShown && !this.areClientsShown && !this.isOpenLink) {
				return true;
			}
			if (resourcesPaths.includes(path) && menuItem === 'Resources' && !this.isFeaturesShown && !this.isHelpShown && !this.areClientsShown && !this.isOpenLink) {
				return true;
			}
			return false;
		},
	},

	beforeMount() {
		this.checkIfMenuIsOpen();
		this.checkIfBodyIsScrollable();
	},

	mounted() {
		window.addEventListener('scroll', this.onScroll), window.addEventListener('resize', this.onResize);
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll), window.removeEventListener('resize', this.onResize);
	},

	components: {
		ATInAction,
		Features,
		Clients,
		Resources,
		Help,
		AboveHeader,
	},

	directives: {
		ClickOutside,
	},
};
</script>

<style lang="scss" scoped>
@import '../../../../scss/variables.scss';
@import '../../../../scss/layout/header/header-submenu.scss';

$urlToImg: '/dist/img';

.header-wrap {
	grid-column: 1/-1;
	display: grid;
}

.header {
	position: fixed;
  top: 0;
	width: 100%;
	transition: 0.3s linear;
	z-index: 5;
	height: 100px;

	@media (max-width: $screen-md-min) {
		position: absolute;
		height: 95px;
	}

    .link-arrow {
        background: #f0ecfb;
        border-radius: 15px;
        justify-content: center;
    }

	.slide-enter-active {
		transition: all 0.3s ease;
	}
	.slide-leave-active {
		transition: all 0.1s ease-in-out;
	}
	.slide-enter {
		transform: translateY(-600px);
	}
	.slide-leave-to {
		transform: translateY(0);
		opacity: 0;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: all 0.5s;
	}
	.fade-enter,
	.fade-leave {
		opacity: 0;
	}

	&__buttons {
		display: flex;

		@media (max-width: 992px) {
			position: absolute;
			top: -44px;
			right: 88px;
		}

		@media (max-width: 600px) {
			top: 0;
			right: auto;
			width: 100%;
			justify-content: center;
			column-gap: 15px;

			a {
				margin: 0;
			}
		}
	}

	&__inner {
		grid-template-columns: repeat(32, 1fr);
		grid-column: 1 / span 32;
		display: grid;
		background: #fff;
		padding: 5px 0;
		border: 1px solid #e8ebf0;

		@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
			background: #fff;
			z-index: 4;
		}

		&--shadow {
			background: #fff;
			z-index: 4;
		}

		@media (max-width: $screen-md-min) {
			padding: 9px 0;
		}
	}

	&__container {
		grid-column: 6/-6;
		display: flex;
		justify-content: space-between;
		align-items: center;

		@media (max-width: 1650px) {
			grid-column: 2/-2;
		}

		@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			width: 100%;
			max-width: 1500px;
			margin: 0 auto;
		}
	}

	&__logo {
		display: flex;
		align-items: center;

		a {
			display: inline-flex;

			img {
				@media (max-width: 1320px) {
					max-width: 100px;
				}
			}
		}
	}

	&__menu-wrap {
		display: flex;
		align-items: baseline;

		@media (max-width: $screen-md-min) {
			display: none;
		}

		&--visible {
			@media (max-width: $screen-md-min) {
				display: flex;
				position: absolute;
				top: 100%;
				left: 0;
				flex-wrap: nowrap;
				width: 100%;
				justify-content: space-between;
				align-items: flex-start;
				background-color: #ffffff;
			}

			@media (max-width: 500px) {
				flex-direction: column-reverse;
			}

			@media (max-width: 395px) {
				top: 115%;
			}
		}

		> .header-submenu__in-action {
			display: flex;
			flex-direction: column;
			padding: 50px 49px 60px 10px;

			@media (max-width: 550px) {
				padding-right: 25px;
			}

			@media (max-width: 500px) {
				display: none;
			}

			&:before {
				top: 50px;
				height: 409px;
			}

			.header-submenu__items--in-action {
				grid-template-columns: 1fr;

				.header-submenu__item-in-action {
					margin-bottom: 10px;
					max-width: 319px;
					width: 100%;
				}
			}
		}
	}

  &-submenu__item {
    padding-left: 10px;
  }

	&__menu {
		grid-column: 18 / span 11;
		display: flex;
		list-style-type: none;
		margin-right: 30px;
		margin-bottom: 0;

		@media (max-width: $screen-lg-min) {
			padding-left: 20px;
		}

		@media (max-width: $screen-md-min) {
			flex-wrap: wrap;
			flex-direction: column;
			align-items: flex-start;
			padding: 0;
			margin: 50px 15px 40px 60px;
		}

		@media (max-width: $screen-xs-min) {
			margin-top: 45px;
		}
	}

	&__li {
		margin-right: 35px;
		color: #000000;
		cursor: pointer;

		.header__link {
			padding: 5px 10px;
			display: block;
			height: 100%;
		}

		@media (max-width: $screen-lg-min) {
			margin-right: 30px;
			font-size: 16px;
		}

		@media (max-width: $screen-md-min) {
			position: relative;
			font-weight: 400;
			font-size: 18px;
			margin-bottom: 15px;
			transition: transform 0.3s ease;
			white-space: nowrap;

			&:last-of-type {
				margin-bottom: 0;
			}

			&:before {
				content: '';
				position: absolute;
				top: 5px;
				left: -35px;
				width: 30px;
				height: 30px;
				background-image: url('#{$urlToImg}/header/icons/features.svg');
				background-size: 100%;
				background-repeat: no-repeat;
			}

			&:nth-child(1) {
				&:before {
					background-image: url('#{$urlToImg}/header/icons/features.svg');
				}
			}

			&:nth-child(2) {
				&:before {
					background-image: url('#{$urlToImg}/header/icons/clients.svg');
				}
			}

			&:nth-child(3) {
				&:before {
					background-image: url('#{$urlToImg}/header/icons/pricing.svg');
				}
			}

			&:nth-child(4) {
				&:before {
					background-image: url('#{$urlToImg}/header/icons/help.svg');
				}
			}

			&:nth-child(5) {
				&:before {
					background-image: url('#{$urlToImg}/header/icons/resources.svg');
				}
			}
		}

		@media (max-width: 600px) {
			margin-right: 10px;
		}

		@media (max-width: $screen-md-min) and (min-width: 769px) {
			&:hover {
				transform: translateX(30px);
			}
		}

		&:hover {
			background: #f7f5fc;
			border-radius: 3px;

			@media (max-width: $screen-md-min) {
				background: #ffffff;
			}
		}

		&:last-of-type {
			margin-right: 0;
		}

		&--parent {
			padding: 5px 25px 5px 15px;
			position: relative;

			> span {
				position: relative;
				color: #000000;
			}

			> span:after {
				position: absolute;
				content: url('#{$urlToImg}/ic-arrow-down-menu.svg');
				top: -5px;
				right: -15px;
				transition: transform 0.2s;
			}

			@media (max-width: 1320px) {
				padding: 5px;
			}

			@media (max-width: $screen-md-min) {
				> span:after {
					top: -3px;
					transform: rotate(-90deg);
				}
			}
		}

		&--open {
			@media (min-width: $screen-md-min) {
				background-color: #f0ecfb;
				border-radius: 3px;

				&:hover {
					background-color: #f0ecfb;
				}
			}
		}

		&--active {
			background-color: #ffffff;
			border-radius: 3px;

			@media (min-width: $screen-md-min) {
				background-color: #f7f5fc;

				&:hover {
					background-color: #f7f5fc;
				}
			}

			@media (max-width: $screen-md-min) and (min-width: 769px) {
				transform: translateX(30px);
			}

			@media (max-width: 550px) {
				padding-right: 0;
			}

			> span:after {
				transform: rotate(-180deg);
				top: -2px;
				transition: transform 0.2s;
			}

			@media (max-width: $screen-md-min) {
				> span:after {
					transform: rotate(-90deg);
					top: -5px;
				}
			}

			@media (max-width: $screen-sm-min) {
				> span:after {
					transform: rotate(0deg);
				}
			}
		}
	}

	&__link {
		color: #000000;
	}

	&__button {
		font-size: 16px;
		height: 40px;
		line-height: 40px;
		border-radius: 50px;
		margin: 0;
		box-shadow: 0px 11px 20px rgba(0, 193, 77, 0.2);

		@media (max-width: 500px) {
			position: relative;
			top: 0;
			right: 0;
			align-self: center;
			margin: 15px;

		}
	}

	&__burger {
		display: none;
		width: 24px;
		height: 16px;
		align-items: center;
		position: relative;

		@media (max-width: $screen-md-min) {
			display: flex;
		}

		&:before {
			top: 0;
			position: absolute;
			content: '';
			display: block;
			width: 100%;
			height: 2px;
			background: $main-text-color;
			transition: 0.2s;
		}

		&:after {
			bottom: 0;
			position: absolute;
			content: '';
			display: block;
			width: 100%;
			height: 2px;
			background: $main-text-color;
			transition: 0.2s;
		}

		&--close {
			&:before {
				transform: translate3d(0, -20px, 0) rotate(45deg);
				top: 27px;
			}

			&:after {
				transform: translate3d(0, -20px, 0) rotate(-45deg);
				bottom: -13px;
			}

			span {
				display: none;
			}
		}

		span {
			width: 100%;
			height: 2px;
			background: $main-text-color;
		}
	}

	&__mobile-title {
		display: none;
		position: absolute;
		top: calc(100% + 10px);
		width: calc(100% - 50px);
		left: 0;
		background: #fff;
		align-items: center;
		padding: 25px 0 15px;
		border-bottom: 1px solid #c6cfdd;
		margin: 0 25px;

		@media (max-width: $screen-md-min) {
			display: flex;
		}

		.header-submenu__link {
			margin: 0;

			&:hover {
				background: transparent;
			}
		}
	}

	&__close-submenu {
		line-height: 1;
		margin-right: 5px;
	}

	&__login-button.button {
		font-size: 16px;
		font-weight: 400;
		line-height: 27px;
		color: #6d79f8;
		background: #ffffff;
		border: 1px solid #6d79f8;
		border-radius: 50px;
		margin-right: 10px;
		height: 40px;

		&:hover {
			background: #f5f5f5;
		}
	}
}

.header-bg {
	background: #283d54;
	opacity: 0.24;
	position: fixed;
	top: 0;
	min-height: 100vh;
	height: auto;
	width: 100vw;
	z-index: 1;
}

.button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 7px 30px;
    max-width: 230px;
    margin: 0 auto;
    border: none;
    border-radius: 30px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    background-color: #42c657;
    transition: .2s;
    cursor: pointer;

    @media (max-width: 500px) {
        margin: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/header/Header.vue